export const ZIndexType = {
  APPBAR: 'appBar',
  DRAWER: 'drawer',
  MOBILESTEPPER: 'mobileStepper',
  MODAL: 'modal',
  SNACKBAR: 'snackbar',
  SPEEDDIAL: 'speedDial',
  TOOLTIP: 'tooltip',
};
